
import '../index.css';

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';


import {
  ActivityIcon,
  IconChip,
  InsightsIcon,
  CalendarIcon,
  PlanIcon,
  RocketIcon,
  DirectionIcon,
} from '../../../components/ui/AppIcon';

import StatusBadge from '../../../components/ui/StatusBadge';


import http from '../../../api/http';

const reportRecords = async (slug, params = {}) => {
  const response = await http.get(`/reports/${slug}`, { params });
  return response.data;
};




const model = {

  reports: [
    {
      handle: 'summary7',
      slug: 'summary',
      params: { windowDays: 7 }
    },
    {
      handle: 'summary30',
      slug: 'summary',
      params: { windowDays: 30 }
    },
    {
      handle: 'summary90',
      slug: 'summary',
      params: { windowDays: 90 }
    },
    {
      handle: 'activity',
      slug: 'activity',
      params: { limit: 8 }
    },
  ],

};


const details = [

  ({ reports }) => {

    const activityFeed = Array.isArray(reports.activity) ? reports.activity : Array.isArray(reports.activity?.data) ? reports.activity.data : [];

    const overdue30 = ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary30, 'overdue');

    const upcoming7 =  ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary7, 'upcoming');

    const upcoming30 =  ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary30, 'upcoming');

    const upcoming90 =  ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary90, 'upcoming');

    const activePlanCount = reports.summary30?.modules?.stratPlans?.byStatus?.active || 0;
    const activeSprintCount = reports.summary30?.modules?.sprintPacks?.byStatus?.active || 0;
    const recentActivityCount = activityFeed.length || 0;

    const primaryInsight = (() => {
      if (overdue30 > 0) {
        return {
          title: 'Overdue work needs attention',
          body: `${overdue30} items are already past their end date. Start with the Reports watchlist to triage risk.`,
          linkTo: '/reports',
          linkLabel: 'Open Reports',
        };
      }
      if (activePlanCount > activeSprintCount) {
        return {
          title: 'Execution is trailing planning',
          body: 'You have more active plans than active sprint packs. Consider converting strategy into active delivery windows.',
          linkTo: '/sprint-packs',
          linkLabel: 'Open SprintPacks',
        };
      }
      if (recentActivityCount < 4) {
        return {
          title: 'Recent execution activity is light',
          body: 'The activity feed is relatively quiet. Review whether updates, weekly check-ins, or task movement are happening often enough.',
          linkTo: '/stat-tracker-entries',
          linkLabel: 'Open StratTracker',
        };
      }
      return {
        title: 'Portfolio health looks stable',
        body: 'Current signals show active planning and manageable deadlines. Focus on maintaining execution cadence and closing loops.',
        linkTo: '/dashboard',
        linkLabel: 'Open Dashboard',
      };
    })();


    const summaryRows = [
      {
        key: 'upcoming7',
        label: 'Upcoming in 7 days',
        value: upcoming7,
      },
      {
        key: 'upcoming30',
        label: 'Upcoming in 30 days',
        value: upcoming30,
      },
      {
        key: 'upcoming90',
        label: 'Upcoming in 90 days',
        value: upcoming90,
      },
      {
        key: 'recentActivity',
        label: 'Recent activity',
        value: recentActivityCount,
      },
    ].map((item) => ({
      ...item,
      icon: item.key === 'recentActivity' ? ActivityIcon : CalendarIcon,
    }));

    return (
      <section className="card dashboard-hero">
        <div className="hero-grid">

          <div className="stack-sm">
            <div className="pill-row">
              <span className="pill pill-green">Insight Engine v1</span>
              <StatusBadge value={overdue30 > 0 ? 'at_risk' : 'on_track'} />
            </div>
            <div className="stack-sm">
              <p className="eyebrow">Primary signal</p>
              <h2 className="hero-title">{primaryInsight.title}</h2>
              <p className="hero-copy">{primaryInsight.body}</p>
            </div>
            <div className="action-cluster">
              <Link className="button-primary" to={primaryInsight.linkTo}>{primaryInsight.linkLabel}</Link>
            </div>
          </div>

          <div className="card-subsection hero-side-panel">
            <div className="metric-head">
              <IconChip tone="gold">
                <InsightsIcon />
              </IconChip>
              <div>
                <p className="eyebrow">Snapshot</p>
                <h3 className="section-title">What changed</h3>
              </div>
            </div>
            <div className="stack-sm">
              {summaryRows.map((row) => (
                <div className="row-between" key={row.key}>
                  <span className="hero-stat-label">{row.label}</span>
                  <strong>{row.value}</strong>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>
    );
  },

  ({ reports }) => {

    const overdue30 = ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary30, 'overdue');


    const activePlanCount = reports.summary30?.modules?.stratPlans?.byStatus?.active || 0;
    const totalPlans = reports.summary30?.modules?.stratPlans?.total || 0;
    const totalSprints = reports.summary30?.modules?.sprintPacks?.total || 0;
    const activePlanRatio = totalPlans ? Math.round((activePlanCount / totalPlans) * 100) : 0;
    const executionCoverage = totalPlans ? Math.round((totalSprints / totalPlans) * 100) : 0;

    const atRiskPlans = (reports.summary30?.modules?.stratPlans?.byStatus?.at_risk || 0) + (reports.summary30?.modules?.stratPlans?.byStatus?.off_track || 0);


    const metricCards = [
      {
        key: 'overdue30',
        tone: 'gold',
        icon: CalendarIcon,
        label: 'Overdue items in 30-day window',
        value: overdue30,
        linkTo: '/reports',
        linkLabel: 'Open Reports',
      },
      {
        key: 'activePlanRatio',
        tone: 'purple',
        icon: PlanIcon,
        label: 'Plans currently active',
        value: `${activePlanRatio}%`,
        linkTo: '/sprint-packs',
        linkLabel: 'Open SprintPacks',
      },
      {
        key: 'executionCoverage',
        tone: 'blue',
        icon: RocketIcon,
        label: 'SprintPack coverage vs plans',
        value: `${executionCoverage}%`,
        linkTo: '/sprint-packs',
        linkLabel: 'Open SprintPacks',
      },
      {
        key: 'riskPlans',
        tone: 'green',
        icon: ActivityIcon,
        label: 'Plans flagged at risk or off track',
        value: atRiskPlans,
        linkTo: '/reports',
        linkLabel: 'Review risk',
      },
    ];

    return (
      <div className="card-grid metrics-grid">

        {metricCards.map((card) => {

          const Icon = card.icon;

          return (
            <article className="card metric-card" key={card.key}>
              <div className="metric-head">
                <IconChip tone={card.tone}>
                  <Icon />
                </IconChip>
                <h3 className="section-title">{card.value}</h3>
              </div>
              <p>{card.label}</p>
              {card.linkTo ? (
                <Link className="inline-link" to={card.linkTo}>{card.linkLabel}</Link>
              ) : null}
            </article>
          );
        })}

      </div>
    );
  },

  ({ reports }) => {

    const activityFeed = Array.isArray(reports.activity) ? reports.activity : Array.isArray(reports.activity?.data) ? reports.activity.data : [];

    const overdue30 = ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary30, 'overdue');

    const upcoming7 =  ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary7, 'upcoming');

    const upcoming30 =  ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary30, 'upcoming');

    const upcoming90 =  ((summary, kind) => {
      const bucket = summary?.dateWindows?.[kind] || {};
      return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
    })(reports.summary90, 'upcoming');

    const activePlanCount = reports.summary30?.modules?.stratPlans?.byStatus?.active || 0;
    const activeSprintCount = reports.summary30?.modules?.sprintPacks?.byStatus?.active || 0;
    const draftStrategies = reports.summary30?.modules?.directionalStrategies?.byStatus?.draft || 0;

    
    const recentActivityCount = activityFeed.length || 0;

    const recommendations = [];

    if (overdue30 > 0) {
      recommendations.push({
        title: 'Triage overdue items first',
        detail: `${overdue30} items are overdue in the 30-day window.`,
        to: '/reports',
      });
    }
    if (activePlanCount > activeSprintCount) {
      recommendations.push({
        title: 'Close the strategy-to-execution gap',
        detail: `${activePlanCount} active plans are supported by only ${activeSprintCount} active sprint packs.`,
        to: '/sprint-packs',
      });
    }
    if (draftStrategies > 0) {
      recommendations.push({
        title: 'Review draft directional strategies',
        detail: `${draftStrategies} strategies are still in draft and may need activation or archival.`,
        to: '/directional-strategies',
      });
    }
    if (recentActivityCount < 4) {
      recommendations.push({
        title: 'Increase execution cadence',
        detail: 'Recent activity is light; encourage weekly updates or more task movement.',
        to: '/stat-tracker-entries',
      });
    }

    if (recommendations.length === 0) {
      recommendations.push({
        title: 'Maintain current rhythm',
        detail: 'Current signals look healthy. Keep reviewing execution and deadlines on a weekly cadence.',
        to: '/dashboard',
      });
    }

    return (
      <div className="card-grid two-col">

        <section className="card">
          <div className="row-between">
            <h3 className="section-title">Recommendations</h3>
            <span className="pagination-label">Actionable next steps</span>
          </div>
          <ul className="simple-list">
            {recommendations.map((item) => (
              <li key={item.title}>
                <div className="stack-sm">
                  <Link className="inline-link" to={item.to}>
                    <strong>{item.title}</strong>
                  </Link>
                  <span className="activity-subtitle">{item.detail}</span>
                </div>
              </li>
            ))}
          </ul>
        </section>

        <section className="card">
          <div className="row-between">
            <h3 className="section-title">Trend Windows</h3>
            <span className="pagination-label">Comparing planning horizons</span>
          </div>
          <table className="data-table">
            <thead>
              <tr>
                <th>Window</th>
                <th>Upcoming</th>
                <th>Overdue</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>7 days</td>
                <td>{upcoming7}</td>
                <td>
                  {((summary, kind) => {
                    const bucket = summary?.dateWindows?.[kind] || {};
                    return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
                  })(reports.summary7, 'overdue')}
                </td>
              </tr>
              <tr>
                <td>30 days</td>
                <td>{upcoming30}</td>
                <td>{overdue30}</td>
              </tr>
              <tr>
                <td>90 days</td>
                <td>{upcoming90}</td>
                <td>
                  {((summary, kind) => {
                    const bucket = summary?.dateWindows?.[kind] || {};
                    return (bucket.directionalStrategies || 0) + (bucket.stratPlans || 0) + (bucket.sprintPacks || 0);
                  })(reports.summary90, 'overdue')}
                </td>
              </tr>
            </tbody>
          </table>
        </section>

      </div>
    );
  },

  ({ reports }) => {

    const activityFeed = Array.isArray(reports.activity) ? reports.activity : Array.isArray(reports.activity?.data) ? reports.activity.data : [];


    const activePlanCount = reports.summary30?.modules?.stratPlans?.byStatus?.active || 0;
    const activeSprintCount = reports.summary30?.modules?.sprintPacks?.byStatus?.active || 0;
    
    const recentActivityCount = activityFeed.length || 0;

    return (
      <div className="card-grid two-col">

        <section className="card">
          <div className="row-between">
            <h3 className="section-title">Status Signals</h3>
            <span className="pagination-label">High-level portfolio state</span>
          </div>
          <table className="data-table">
            <thead>
              <tr>
                <th>Signal</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Draft strategies</td>
                <td>{reports.summary30?.modules?.directionalStrategies?.byStatus?.draft || 0}</td>
              </tr>
              <tr>
                <td>Active plans</td>
                <td>{activePlanCount}</td>
              </tr>
              <tr>
                <td>Active sprint packs</td>
                <td>{activeSprintCount}</td>
              </tr>
              <tr>
                <td>Recent activity items</td>
                <td>{recentActivityCount}</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section className="card">
          <div className="row-between">
            <h3 className="section-title">Recent Signals</h3>
            <span className="pagination-label">Latest cross-module movement</span>
          </div>
          <ul className="activity-list">
            {activityFeed.map((item) => (
              <li key={`${item.entityType}-${item.entityId}-${item.updatedAt}`}>
                <div className="activity-item">
                  <IconChip tone="green">
                    <ActivityIcon />
                  </IconChip>
                  <div>
                    <Link className="inline-link" to={((item) => {
                      if (!item) return '/dashboard';
                      if (item.entityType === 'directionalStrategy') return '/directional-strategies';
                      if (item.entityType === 'stratPlan') return `/strat-plans/${item.entityId}`;
                      if (item.entityType === 'sprintPack') return `/sprint-packs/${item.entityId}`;
                      if (item.entityType === 'task') return '/sprint-packs';
                      return '/dashboard';
                    })(item)}>
                      <strong>
                        {((item) => {
                          if (!item) return 'Activity item';
                          const type = String(item.entityType || '')
                            .replace(/([a-z])([A-Z])/g, '$1 $2')
                            .replace(/[_-]+/g, ' ');
                          const typeLabel = type ? `${type[0].toUpperCase()}${type.slice(1)}` : 'Item';
                          return `${typeLabel} updated: ${item.label || item.entityId}`;
                        })(item)}
                      </strong>
                    </Link>
                    <span className="activity-subtitle">
                      <StatusBadge value={item.status || 'updated'} />
                    </span>
                  </div>
                  <span className="activity-time">
                    {((value) => {
                      if (!value) return '-';
                      const date = new Date(value);
                      if (Number.isNaN(date.getTime())) return '-';
                      return date.toLocaleDateString();
                    })(item.updatedAt)}
                  </span>
                </div>
              </li>
            ))}
            {activityFeed.length === 0 ? <li>No recent signals found.</li> : null}
          </ul>
        </section>

      </div>
    );
  },

];





const Component = () => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');


  const [reports, setReports] = useState({});

  useEffect(() => {

    const loadContext = async () => {
      setLoading(true);
      setError('');
      try {

        await ( async () => {

          const result = {};

          await Promise.all(
            model.reports.map( async ( item ) => {
              result[ item.handle ] = await reportRecords( item.slug, item.params )
            } )
          );

          setReports( result );
        } )();

      } catch (err) {
        setError(err?.response?.data?.message || err.message || 'Unable to load insights.');
      } finally {
        setLoading(false);
      }
    }

    loadContext();
  }, []);


  if (loading) return <p>Loading insights...</p>;
  if (error) return <p className="error-text">{error}</p>;


  return (
    <div className="stack">

      <section className="card page-hero page-header">
        <div>
          <h1 className="page-title">Insights</h1>
          <p className="page-subtitle">Decision support based on current planning, execution, deadlines, and activity signals.</p>
        </div>
      </section>

      {details.map( ( Detail ) => {
        return <Detail reports={reports} />;
      } )}

    </div>
  );
}

export default Component;